import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { Directive, HostListener } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';

// Scrolls to top of step header when step is changed
// Delete this once https://github.com/angular/material2/issues/8881 is resolved

@Directive({
  selector: '[csiMatVerticalStepperScroller]'
})
export class MatVerticalStepperScrollerDirective {
  constructor(private stepper: MatStepper) {}

  @HostListener('selectionChange', ['$event'])
  selectionChanged(selection: StepperSelectionEvent) {
    const stepId = this.stepper._getStepLabelId(selection.selectedIndex);
    const stepElement = document.getElementById(stepId);
    if (stepElement) {
      setTimeout(() => {
        stepElement.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
      }, 300);
    }
  }
}
